module.exports = __webpack_public_path__ + "img/image (2).ba011501.jpg";